<template>
    <div class="staking-income-distribution">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="收益列表" name="INCOMELIST"></el-tab-pane>
            <el-tab-pane label="生成收益" name="CREATRINCOME"></el-tab-pane>
            <el-tab-pane label="发放收益" name="GRANTINCOME"></el-tab-pane>
            <el-tab-pane label="删除收益" name="DELETEINCOME"></el-tab-pane>
        </el-tabs>
        <el-form :inline="true" class="header-box">
            <div v-if="activeName=='CREATRINCOME'">
                <el-form-item label="锁仓总量">
                    <span>{{lockingTotal}}</span>
                </el-form-item>
                <el-form-item label="解锁中总量">
                    <span>{{unlockingTotal}}</span>
                </el-form-item>
            </div>
            <el-form-item label="锁仓币种："
                          v-if="activeName=='INCOMELIST' || activeName=='CREATRINCOME' || activeName=='DELETEINCOME' || activeName=='GRANTINCOME'">
                <el-select v-model="serchInfo.lockCoinType" filterable placeholder="请选择币种"
                           @change="getLockingTotal(true)">
                    <el-option v-for="item in coinTypes" :key="item.id" :label="item.coinType" :value="item.coinType">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="收益币种："
                          v-if="activeName=='INCOMELIST' || activeName=='CREATRINCOME' || activeName=='DELETEINCOME' || activeName=='GRANTINCOME'">
                <el-select v-model="serchInfo.incomeCoinType" filterable placeholder="请选择币种">
                    <el-option v-for="(item,index) in incomeCoinList" :key="index" :label="item" :value="item">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="用户ID" v-if="activeName=='INCOMELIST'">
                <el-input v-model="serchInfo.userId" placeholder="用户ID" style="width: 300px"></el-input>
            </el-form-item>

            <el-form-item label="收益日期"
                          v-if="activeName=='INCOMELIST' || activeName=='CREATRINCOME' || activeName=='DELETEINCOME' || activeName=='GRANTINCOME'">
                <el-date-picker v-model="serchInfo.incomeTime" value-format="timestamp" type="datetime"
                                placeholder="请选择"
                                @change="getLockingTotal(false)">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="昨日锁仓资产" v-if="activeName=='CREATRINCOME'">
                <el-input v-model="serchInfo.lockTotal" placeholder="昨日锁仓资产"></el-input>
            </el-form-item>

            <el-form-item label="昨日挖矿收益" v-if="activeName=='CREATRINCOME'">
                <el-input v-model="serchInfo.incomeTotal" placeholder="昨日挖矿收益"></el-input>
            </el-form-item>


            <el-form-item>
                <el-button type="primary" @click="search()"
                           v-if="activeName=='INCOMELIST' || activeName=='GRANTINCOME' || activeName=='DELETEINCOME'">搜索
                </el-button>
                <el-button type="success" @click="createIncome()" v-if="activeName=='CREATRINCOME'">生成奖励</el-button>
                <el-button type="danger" @click="grantIncome()" v-if="activeName=='GRANTINCOME'">发放奖励</el-button>
                <el-button type="danger" @click="oneKeyGrantIncome()" v-if="activeName=='GRANTINCOME'">一键发放</el-button>
                <el-button type="danger" @click="deleteIncome()" v-if="activeName=='DELETEINCOME'">删除奖励</el-button>
            </el-form-item>

            <el-upload v-if="activeName=='CREATRINCOME'" style="display: inline-block;margin-left: 10px" ref="upload"
                       action=""
                       :auto-upload="false" :show-file-list="false" accept="xlsx,xls,csv"
                       :on-change="onFileChange">
                <el-button slot="trigger" icon="el-icon-upload" type="primary">导入文件</el-button>
            </el-upload>

        </el-form>

        <el-table :data="listInfo" :row-key="() => Math.random()">
            <el-table-column label="记录ID" prop="id"></el-table-column>
            <el-table-column label="用户ID" prop="userId"></el-table-column>
            <el-table-column label="锁仓币种ID" prop="stakingCoinId"></el-table-column>
            <el-table-column label="锁仓币种" prop="lockCoinType"></el-table-column>
            <el-table-column label="收益币种" prop="coinType"></el-table-column>
            <el-table-column label="矿池总锁仓量" prop="lockedTotal"></el-table-column>
            <el-table-column label="矿池总收益" prop="incomeTotal"></el-table-column>
            <el-table-column label="用户总锁仓量" prop="lockedAmount"></el-table-column>
            <el-table-column label="用户总收益" prop="incomeAmount"></el-table-column>
            <el-table-column label="收益时间" prop="incomeTime">
                <template slot-scope="scope">{{ scope.row.incomeTime | moment }}</template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime">
                <template slot-scope="scope">{{ scope.row.createTime | moment }}</template>
            </el-table-column>
            <el-table-column label="更新时间" prop="updateTime">
                <template slot-scope="scope">{{ scope.row.updateTime | moment }}</template>
            </el-table-column>
            <el-table-column label="状态" prop="status">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 1">创建</span>
                    <span v-if="scope.row.status == 2">确认发放</span>
                    <span v-else-if="scope.row.status == 3">发放完成</span>
                </template>
            </el-table-column>
        </el-table>

        <div class="footer-box" style="margin-top: 20px">
            <el-pagination
                    @size-change="sizeChange"
                    @current-change="pageChange"
                    :current-page="serchInfo.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="serchInfo.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
            </el-pagination>
        </div>

        <el-dialog title="导入数据" :visible.sync="dialogVisible" width="60%" @close="clearData"
                   :close-on-click-modal="false">
            <el-table class="data-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="importData" :row-key="() => Math.random()">
                <el-table-column prop="lockCoinType" label="锁仓币种(lockCoinType)"></el-table-column>
                <el-table-column prop="incomeCoinType" label="奖励币种(incomeCoinType)"></el-table-column>
                <el-table-column prop="incomeTime" label="奖励时间(incomeTime)"></el-table-column>
                <el-table-column prop="lockTotal" label="锁仓总数(lockTotal)"></el-table-column>
                <el-table-column prop="incomeTotal" label="奖励总数(incomeTotal)"></el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="calculateStakingAward">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import XLSX from 'xlsx';

    export default {
        name: "match",
        data() {
            return {
                accept: ['xlsx', 'xls', 'csv'],
                listInfo: [], //数据列表
                total: 0, //总条数
                serchInfo: {
                    lockCoinType: "",
                    incomeCoinType: "",
                    incomeTime: "",
                    userId: "",
                    lockTotal: "",
                    incomeTotal: "",
                    page: 1,
                    size: 10,
                },
                activeName: "INCOMELIST",
                coinTypes: [],
                lockingTotal: 0,
                unlockingTotal: 0,
                incomeCoinList: [],
                dialogVisible: false,
                importData: [],
                loading: false
            };
        },
        created() {
            this.getPairList();
            this.getIncomeList(this.serchInfo)
        },
        methods: {
            search() {
                this.serchInfo.page = 1;
                this.getIncomeList(this.serchInfo)
            },
            getLockingTotal(tag, value) {
                if (this.serchInfo.lockCoinType != "" && tag) {
                    api.getCoinInfo({coinType: this.serchInfo.lockCoinType}).then(({data}) => {
                        this.incomeCoinList = data.incomeCoinList ? JSON.parse(data.incomeCoinList) : [];
                    });
                }
                if (this.serchInfo.lockCoinType == "" || this.serchInfo.incomeTime == null || this.serchInfo.incomeTime == "") {
                    return;
                }
                if (this.activeName != "CREATRINCOME") {
                    return;
                }
                api.getLockingTotal(this.serchInfo).then(({data}) => {
                    this.lockingTotal = data == null ? 0 : data;
                });
                api.getUnlockingTotal(this.serchInfo).then(({data}) => {
                    this.unlockingTotal = data == null ? 0 : data;
                });
            },
            getIncomeList(query) {
                if (this.activeName != 'INCOMELIST') {
                    if (this.serchInfo.incomeTime == null || this.serchInfo.incomeTime == "") {
                        this.$message.success("请选择收益日期");
                        return;
                    }
                }
                api.getIncomeList(query).then(({data}) => {
                    this.total = data.totalCount;
                    this.listInfo = data.list;
                })
            },
            sizeChange(val) {
                this.serchInfo.size = val;
                this.getIncomeList(this.serchInfo);
            },
            pageChange(val) {
                this.serchInfo.page = val;
                this.getIncomeList(this.serchInfo);
            },
            createIncome() {
                if (this.serchInfo.lockCoinType == "") {
                    this.$message.success("请选择锁仓币种");
                    return;
                }
                if (this.serchInfo.incomeCoinType == "") {
                    this.$message.success("请选择收益币种");
                    return;
                }
                if (this.serchInfo.incomeTime == "" || this.serchInfo.incomeTime == null) {
                    this.$message.success("请选择收益日期");
                    return;
                }
                if (this.serchInfo.lockTotal == "") {
                    this.$message.success("请输入昨日锁仓资产");
                    return;
                }
                if (this.serchInfo.incomeTotal == "") {
                    this.$message.success("请输入昨日挖矿收益");
                    return;
                }
                api.checkGrant(this.serchInfo).then(res => {
                    if (res.code == 0 && res.data == false) {
                        api.createIncome(this.serchInfo).then(res => {
                            if (!res.code) {
                                this.$message.success(res.msg);
                                this.getIncomeList(this.serchInfo);
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    } else {
                        this.$confirm('当天收益已生成，是否再次生成？', '提示', {
                            type: 'warning'
                        }).then(() => {
                            api.createIncome(this.serchInfo).then(res => {
                                if (!res.code) {
                                    this.$message.success(res.msg);
                                    this.getIncomeList(this.serchInfo);
                                } else {
                                    this.$message.error(res.msg);
                                }
                            });
                        }).catch(() => {
                        });
                    }
                });
            },
            calculateStakingAward() {
                if (!this.importData || this.importData.length <= 0) {
                    this.$message.error("数据不能为空！");
                    return;
                }
                this.$confirm('确认导入这些数据吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    api.calculateStakingAward({incomeDtoJson: JSON.stringify(this.importData)}).then((rep) => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$message.success(rep.msg);
                        this.reflashData();
                    });
                }).catch(() => {
                });
            },
            onFileChange(file) {
                if (!file) return;
                const {raw: originFile} = file;
                const {name, size} = originFile;
                const suffix = name.split('.').pop();
                if (!this.accept.includes(suffix)) {
                    this.$message.error(`只能上传${this.acceptStr}格式的文件`);
                    return;
                }
                this.readDataFromFile(originFile);
            },
            readDataFromFile(file) {
                const that = this;
                const reader = new FileReader();
                reader.onload = function (e) {
                    // pre-process data
                    let binary = '';
                    const bytes = new Uint8Array(e.target.result);
                    const length = bytes.byteLength;
                    for (let i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }

                    /* read workbook */
                    const wb = XLSX.read(binary, {
                        type: 'binary'
                    });

                    /* grab first sheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];

                    /* generate HTML */
                    that.importData = XLSX.utils.sheet_to_json(ws);
                    that.dialogVisible = true;
                };
                reader.readAsArrayBuffer(file);
            },
            deleteIncome() {
                if (this.serchInfo.lockCoinType == "") {
                    this.$message.success("请选择锁仓币种");
                    return;
                }
                if (this.serchInfo.incomeCoinType == "") {
                    this.$message.success("请选择收益币种");
                    return;
                }
                if (this.serchInfo.incomeTime == "" || this.serchInfo.incomeTime == null) {
                    this.$message.success("请选择收益日期");
                    return;
                }
                api.deleteIncome(this.serchInfo).then(res => {
                    if (!res.code) {
                        this.$message.success(res.msg);
                        this.getIncomeList(this.serchInfo);
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            //发放
            grantIncome() {
                if (this.serchInfo.lockCoinType == "") {
                    this.$message.success("请选择锁仓币种");
                    return;
                }
                if (this.serchInfo.incomeCoinType == "") {
                    this.$message.success("请选择收益币种");
                    return;
                }
                if (this.serchInfo.incomeTime == "" || this.serchInfo.incomeTime == null) {
                    this.$message.success("请选择收益日期");
                    return;
                }
                api.checkGrant(this.serchInfo).then(res => {
                    if (res.code == 0 && res.data == false) {
                        api.grantIncome(this.serchInfo).then(res => {
                            if (!res.code) {
                                this.$message.success(res.msg);
                                this.getIncomeList(this.serchInfo);
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    } else {
                        this.$confirm('当天收益已发放，是否再次发放？', '提示', {
                            type: 'warning'
                        }).then(() => {
                            api.grantIncome(this.serchInfo).then(res => {
                                if (!res.code) {
                                    this.$message.success(res.msg);
                                    this.getIncomeList(this.serchInfo);
                                } else {
                                    this.$message.error(res.msg);
                                }
                            });
                        }).catch(() => {
                        });
                    }
                });
            },
            oneKeyGrantIncome() {
                if (this.serchInfo.incomeTime == "" || this.serchInfo.incomeTime == null) {
                    this.$message.success("请选择收益日期");
                    return;
                }
                this.$confirm('确认一键发放所有币种收益，发放前请核算收益数据准确？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.oneKeyGrantIncome(this.serchInfo).then(res => {
                        if (!res.code) {
                            this.$message.success(res.msg);
                            this.getIncomeList(this.serchInfo);
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }).catch(() => {
                });
            },
            handleClick() {
                this.listInfo = []; //数据列表
                this.total = 0; //总条数
                this.lockingTotal = 0; //总条数
                this.serchInfo = {
                    lockCoinType: "",
                    incomeTime: "",
                    userId: "",
                    lockTotal: "",
                    incomeTotal: "",
                    incomeCoinType: "",
                    page: 1,
                    size: 10,
                }
            },
            getPairList() {
                api.getStakingCoinList({page: 1, size: 10000}).then(({data}) => {
                    this.coinTypes = data.list;
                });
            },
            clearData() {
                this.importData = [];
                this.loading = false;
            }
        }
    };
</script>

<style lang="less">
    .staking-income-distribution {
        .header-box {
            width: 90%;
            // border: 1px solid #cccccc;
            padding: 16px;
            .el-form-item {
                padding-right: 30px;
            }
        }
    }
</style>
